import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import AccountStatusUpdateModalUI from './AccountStatusUpdateModalUI.js'

class AccountStatusUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      status: this.props.account.status || '',
      statusError: null
    }
  }

  render() {
    let statusList = [
      { key: 'active', value: 'Active' },
      { key: 'frozen', value: 'Frozen' },
      { key: 'inactive', value: 'Inactive' }
    ]
    return (
      <AccountStatusUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        status={this.state.status}
        onStatusChange={(event) => { this.setState({ status: event.target.value }) }}
        statusError={this.state.statusError}
        setStatusError={(error) => { this.setState({ statusError: error }) }}
        statusList={statusList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/status`,
      this.onSubmitCallback,
      {
        status: this.state.status
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default AccountStatusUpdateModalSF
